export default function isDynamicBundle(productData) {
  return (
    productData.product_type === 'bundle' &&
    'bundle_data_only' in productData &&
    productData.is_fixed_bundle !== true
  )
}
